import axios from "axios";
import { Redirect } from "react-router-dom";
import { tokenRefresh } from "./authService";
import {
  getAccessTokenSync,
  isAccessTokenNearExpiry,
} from "./tokenService";

const isRequestCancelled = (error) =>
  !!error &&
  (error.code === "ERR_CANCELED" ||
    error.name === "CanceledError" ||
    error.name === "AbortError" ||
    /canceled|cancelled|aborted/i.test(String(error.message || "")));

const cancelledResponse = () => ({
  cancelled: true,
  msg: "Request cancelled",
  data: null,
  status: 0,
});

// universal methode to call api
export function _callApi(
  data,
  url,
  headerdata = "",
  method = 1,
  querydata,
  headerDetails = "",
  options = {}
) {
  var result;
  var siteSetting = "";
  if (querydata && querydata.length > 0) {
    siteSetting = process.env[url] + querydata;
  } else {
    siteSetting = process.env[url];
  }
  let accessToken = getAccessTokenSync();
  const signal = options?.signal;
  const requestConfig = signal ? { signal } : {};

  if (headerdata === "") {
    headerdata = {
      Authorization: accessToken,
      crossDomain: true,
    };
  } else if (headerdata === "2") {
    headerdata = {
      Authorization: accessToken,
      "Content-Type": "multipart/form-data",
      crossDomain: true,
    };
  } else if (headerdata === "3") {
    headerdata = {
      Authorization: accessToken,
      "Content-Type": "application/json",
      crossDomain: true,
    };
  } else if (headerdata === "6") {
    headerdata = {
      Authorization: accessToken,
      crossDomain: true,
      profile: "REPORT",
    };
  } else if (headerdata === "7") {
    headerdata = {
      Authorization: headerDetails,
      crossDomain: true,
    };
  } else {
    headerdata = {
      crossDomain: true,
    };
  }
  const instance = axios.create({
    baseURL: siteSetting,
    timeout: 300000,
    headers: headerdata,
  });
  instance.interceptors.request.use((req) => {
    const currentToken = getAccessTokenSync() || accessToken;
    if (currentToken) {
      req.headers.Authorization = currentToken;
      if (isAccessTokenNearExpiry(currentToken)) {
        return tokenRefresh()
          .then(() => {
            req.headers.Authorization = getAccessTokenSync();
            return req;
          })
          .catch((error) => {
            console.log("Error:", error);
            let data = localStorage.getItem("browser-tab");
            localStorage.clear();
            localStorage.setItem("browser-tab", data);
            window.location.href = "/#/login";
            throw error;
          });
      }
    }

    return req;
  });

  if (method === 1) {
    // if method post
    result = instance
      .post("", data, requestConfig)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (isRequestCancelled(error)) {
          return cancelledResponse();
        }
        if (error && error.response && error.response.status) {
          var newData = {
            msg: error.toString(),
            data: error.response.data,
            status: error.response.status,
          };
          return newData;
        }
        // if (
        //   error &&
        //   error?.response &&
        //   parseInt(error?.response?.status) === 401
        // ) {
        //   let data = localStorage.getItem("browser-tab");
        //   localStorage.clear();
        //   localStorage.setItem("browser-tab", data);
        //   window.location.href = "/";
        //   return false;
        // } else {
        //   if (error && error.response && error.response.status) {
        //     var newData = {
        //       msg: error.toString(),
        //       data: error.response.data,
        //       status: error.response.status,
        //     };
        //     return newData;
        //   }
        // }
      });
  }
  if (method === 3) {
    // if method post
    result = instance
      .put("", data, requestConfig)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (isRequestCancelled(error)) {
          return cancelledResponse();
        }
        if (error && error.response && error.response.status) {
          var newData = {
            msg: error.toString(),
            data: error.response.data,
            status: error.response.status,
          };
          return newData;
        }
        // if (
        //   error &&
        //   error.response &&
        //   parseInt(error?.response?.status) === 401
        // ) {
        //   let data = localStorage.getItem("browser-tab");
        //   localStorage.clear();
        //   localStorage.setItem("browser-tab", data);
        //   window.location.href = "/?sessionExpired=true";
        //   return false;
        // } else {
        //   if (error && error.response && error.response.status) {
        //     var newData = {
        //       msg: error.toString(),
        //       data: error.response.data,
        //       status: error.response.status,
        //     };
        //     return newData;
        //   }
        // }
      });
  }
  if (method === 2) {
    // if method get

    result = instance
      .get("", { ...(data || {}), ...requestConfig })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (isRequestCancelled(error)) {
          return cancelledResponse();
        }
        if (
          error &&
          error?.response &&
          parseInt(error?.response?.status) === 401
        ) {
          if (parseInt(error?.response?.status) === 401) {
            let data = localStorage.getItem("browser-tab");
            localStorage.clear();
            localStorage.setItem("browser-tab", data);
            // window.location.reload();
            return <Redirect to={{ pathname: "/#/login" }} />;
            //window.location.href = "/?sessionExpired=true";
            //return false;
          } else {
            var newData = {
              msg: error?.toString(),
              data: error?.response?.data || null,
              status: error?.response?.status || 400,
            };
            return newData;
          }
        } else if (
          error &&
          error?.response &&
          parseInt(error?.response?.status) === 400
        ) {
          return error?.response?.data || null;
        } else {
          let newData = {
            msg: error?.toString(),
            data: error?.response?.data || null,
            status: error?.response?.status || 400,
          };
          return newData;
        }
      });
  }
  if (method === 4) {
    // if method delete
    result = instance
      .delete("", { ...(data || {}), ...requestConfig })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (isRequestCancelled(error)) {
          return cancelledResponse();
        }
        if (error && error?.response && error?.response?.status) {
          var newData = {
            msg: error?.toString(),
            data: error?.response?.data || null,
            status: error?.response?.status || 400,
          };
          return newData;
        }
        // if (
        //   error &&
        //   error.response &&
        //   parseInt(error?.response?.status) === 401
        // ) {
        //   let data = localStorage.getItem("browser-tab");
        //   localStorage.clear();
        //   localStorage.setItem("browser-tab", data);
        //   window.location.href = "/?sessionExpired=true";
        //   return false;
        // } else {
        //   if (error && error?.response && error?.response?.status) {
        //     var newData = {
        //       msg: error?.toString(),
        //       data: error?.response?.data || null,
        //       status: error?.response?.status || 400,
        //     };
        //     return newData;
        //   }
        // }
      });
  }
  if (method === 5) {
    // if method patch
    result = instance
      .patch("", data, requestConfig)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (isRequestCancelled(error)) {
          return cancelledResponse();
        }
        if (error && error?.response && error?.response?.status) {
          var newData = {
            msg: error?.toString(),
            data: error?.response?.data || null,
            status: error?.response?.status || 400,
          };
          return newData;
        }
        // if (
        //   error &&
        //   error.response &&
        //   parseInt(error?.response?.status) === 401
        // ) {
        //   let data = localStorage.getItem("browser-tab");
        //   localStorage.clear();
        //   localStorage.setItem("browser-tab", data);
        //   window.location.href = "/?sessionExpired=true";
        //   return false;
        // } else {
        //   if (error && error?.response && error?.response?.status) {
        //     var newData = {
        //       msg: error?.toString(),
        //       data: error?.response?.data || null,
        //       status: error?.response?.status || 400,
        //     };
        //     return newData;
        //   }
        // }
      });
  }
  return result;
}
